<script setup>
import SkeletonPlaceholder from '@/components/Base/SkeletonPlaceholder.vue'

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)

// Fetch Center Details
const { data: centerDetails, suspense: centerDetailSuspense, isPlaceholderData: isCenterDetailsPlaceholder } = useFetchCenterDetails(centerRoute.value)

// Prefetch data on the server side
onServerPrefetch(async () => {
    await centerDetailSuspense() // Wait for the query to finish fetching
})
</script>

<template>
    <div class="center-header">
        <CenterSelector :center-selector-config="{ position: 'content' }" />

        <component
            :is="SkeletonPlaceholder"
            v-if="isCenterDetailsPlaceholder"
            :skeleton-placeholder-config="{ type: 'image', width: '200px', height: '100px' }"
        />

        <NuxtLinkLocale v-else :to="'centerUid'">
            <img
                :src="centerDetails?.logotype?.url"
                :alt="centerDetails?.logotype?.altText || centerDetails?.centerName"
                height="50"
                width="200"
            >
        </NuxtLinkLocale>
    </div>
</template>

<style lang="scss">
.center-header {
    display: none;
    align-items: center;
    justify-content: space-between;

    @include bp(medium1) {
        display: flex;
        margin-block-end: 60px;
    }

    @include bp(large1) {
        display: flex;
        margin-block-end: 120px;
    }

    img {
        min-height: 50px;
        max-height: 80px;
        max-width: 150px;
        min-width: 50px;
        height: auto;
        width: 100%;

        @include bp(large1) {
            max-width: 200px;
        }
    }
}
</style>
